import { useTranslation } from 'react-i18next';
import { NewDropdown, Typography } from 'app/components/ui';
import { useUpdateTag } from 'entities/tag';

const formatOptions = [
  { label: 'num-dot-decimal', value: 'ixt:num-dot-decimal' },
  { label: 'num-comma-decimal', value: 'ixt:num-comma-decimal' },
  { label: 'num-unit-decimal', value: 'ixt:num-unit-decimal' },
  { label: 'fixed-zero (–)', value: 'ixt:fixed-zero' },
  { label: 'num-words-en', value: 'ixt:num-words-en' },
];

interface FormatFieldProps {
  tagId: string;
  documentSuperId: number;
  currentFormat: string | null;
  disabled?: boolean;
}

export const FormatField = ({ tagId, documentSuperId, currentFormat, disabled = false }: FormatFieldProps) => {
  const { t } = useTranslation('tag');

  const { mutate: updateTag } = useUpdateTag();

  const handleUpdate = (format: string) => {
    updateTag({
      id: tagId,
      documentSuperId,
      format: format || null,
    });
  };

  const displayLabel = formatOptions.find((o) => o.value === currentFormat)?.label ?? currentFormat ?? '-';

  return (
    <div className="property-row">
      <Typography fontWeight="semibold" className="property-label">
        {t('format.title')}
      </Typography>
      {disabled ? (
        <Typography variant="body-7" fontWeight="light">
          {displayLabel}
        </Typography>
      ) : (
        <div className="format-dropdown">
          <NewDropdown fullwidth options={formatOptions} currentValue={currentFormat ?? t('format.choose')} onUpdate={handleUpdate} />
        </div>
      )}
    </div>
  );
};
